import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router'
import { AppShell } from './components/AppShell'
import { DashboardPage } from './routes/DashboardPage'
import { PosPage } from './routes/PosPage'
import { SalesPage } from './routes/SalesPage'
import { ShiftsPage } from './routes/ShiftsPage'
import { SuppliersPage } from './routes/SuppliersPage'
import { PurchasesPage } from './routes/PurchasesPage'
import { ExpensesPage } from './routes/ExpensesPage'
import { OrdersPage } from './routes/OrdersPage'
import { ReportsPage } from './routes/ReportsPage'
import { CustomersPage } from './routes/CustomersPage'
import { BranchesPage } from './routes/BranchesPage'
import { SettingsPage } from './routes/SettingsPage'
import { StockTakePage } from './routes/StockTakePage'
import { UsersPage } from './routes/UsersPage'
import { ProductsPage } from './routes/ProductsPage'
import { CategoriesPage } from './routes/CategoriesPage'
import { InventoryPage } from './routes/InventoryPage'
import { MovementsPage } from './routes/MovementsPage'
import { NotFoundPage } from './routes/NotFoundPage'

function RootLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}

const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
})

// تُكتب المسارات صراحةً لا عبر دالة مساعدة: TanStack Router يبني
// أنواع الروابط من القيم الحرفية، وأي تغليف يُفقدها.
const dashboardRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: DashboardPage })
const productsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/products', component: ProductsPage })
const categoriesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/categories', component: CategoriesPage })
const inventoryRoute = createRoute({ getParentRoute: () => rootRoute, path: '/inventory', component: InventoryPage })
const posRoute = createRoute({ getParentRoute: () => rootRoute, path: '/pos', component: PosPage })
const salesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/sales', component: SalesPage })
const shiftsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/shifts', component: ShiftsPage })
const suppliersRoute = createRoute({ getParentRoute: () => rootRoute, path: '/suppliers', component: SuppliersPage })
const purchasesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/purchases', component: PurchasesPage })
const expensesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/expenses', component: ExpensesPage })
const ordersRoute = createRoute({ getParentRoute: () => rootRoute, path: '/orders', component: OrdersPage })
const reportsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/reports', component: ReportsPage })
const customersRoute = createRoute({ getParentRoute: () => rootRoute, path: '/customers', component: CustomersPage })
const branchesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/branches', component: BranchesPage })
const stockTakesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/stock-takes', component: StockTakePage })
const settingsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/settings', component: SettingsPage })
const usersRoute = createRoute({ getParentRoute: () => rootRoute, path: '/users', component: UsersPage })
const movementsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inventory/movements',
  component: MovementsPage,
})

const routeTree = rootRoute.addChildren([
  dashboardRoute,
  productsRoute,
  categoriesRoute,
  inventoryRoute,
  movementsRoute,
  posRoute,
  salesRoute,
  shiftsRoute,
  suppliersRoute,
  purchasesRoute,
  expensesRoute,
  ordersRoute,
  reportsRoute,
  customersRoute,
  branchesRoute,
  stockTakesRoute,
  settingsRoute,
  usersRoute,
])

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
